import { render, staticRenderFns } from "./FriendTag.vue?vue&type=template&id=4304b241&"
import script from "./FriendTag.vue?vue&type=script&lang=js&"
export * from "./FriendTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports